import * as THREE from "three";

/**
 * The exit portal: the gold ring, plus a swirling wormhole in the center
 * (two counter-rotating spiral discs + a pulsing core) and a purple glow.
 */
function vortexTexture() {
  const c = document.createElement("canvas");
  c.width = c.height = 256;
  const x = c.getContext("2d");
  const cx = 128, cy = 128;
  const g = x.createRadialGradient(cx, cy, 3, cx, cy, 128);
  g.addColorStop(0, "#000010");
  g.addColorStop(0.45, "#2a1a5a");
  g.addColorStop(0.8, "#6a44d8");
  g.addColorStop(1, "rgba(150,120,255,0)");
  x.fillStyle = g;
  x.beginPath(); x.arc(cx, cy, 128, 0, Math.PI * 2); x.fill();
  // spiral arms
  x.lineWidth = 3; x.strokeStyle = "rgba(190,160,255,0.75)";
  for (let a = 0; a < 5; a++) {
    x.beginPath();
    for (let t = 0; t <= 1; t += 0.02) {
      const ang = a * (Math.PI * 2 / 5) + t * 7;
      const r = t * 122;
      const px = cx + Math.cos(ang) * r, py = cy + Math.sin(ang) * r;
      if (t === 0) x.moveTo(px, py); else x.lineTo(px, py);
    }
    x.stroke();
  }
  const tex = new THREE.CanvasTexture(c);
  return tex;
}

export function createPortal(pos) {
  const group = new THREE.Group();
  const ring = new THREE.Mesh(
    new THREE.TorusGeometry(1.1, 0.18, 12, 32),
    new THREE.MeshStandardMaterial({ color: 0xc9a24b, emissive: 0xffd24a, emissiveIntensity: 1.2 })
  );
  ring.rotation.x = Math.PI / 2; ring.position.y = 1.2;

  const tex = vortexTexture();
  const mkVortex = (y, scale) => {
    const m = new THREE.Mesh(
      new THREE.CircleGeometry(1.05, 40),
      new THREE.MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, side: THREE.DoubleSide })
    );
    m.rotation.x = -Math.PI / 2; m.position.y = y; m.scale.setScalar(scale);
    return m;
  };
  const v1 = mkVortex(0.12, 1.05);
  const v2 = mkVortex(0.32, 0.68);
  const core = new THREE.Mesh(
    new THREE.SphereGeometry(0.22, 14, 14),
    new THREE.MeshBasicMaterial({ color: 0xcdb8ff })
  );
  core.position.y = 0.55;
  const light = new THREE.PointLight(0x9a6bff, 2.4, 13); light.position.y = 1.0;

  group.add(ring, v1, v2, core, light);
  group.position.copy(pos);
  return { mesh: group, ring, v1, v2, core, pos: pos.clone() };
}

export function updatePortal(p, dt, t) {
  p.ring.rotation.z += dt * 1.4;
  p.v1.rotation.z -= dt * 1.3;
  p.v2.rotation.z += dt * 2.1;
  p.mesh.position.y = Math.sin(t * 0.003) * 0.1;
  p.core.scale.setScalar(1 + Math.sin(t * 0.006) * 0.25);
}
